import * as React from "react";
import { createComponent } from "@lit/react";
import Component from "../../components/DescriptionList/sgds-description-list-group";
import { register } from "../../utils/ce-registry";

register("sgds-description-list-group", Component);

export default createComponent({
  react: React,
  tagName: "sgds-description-list-group",
  elementClass: Component,
  events: {}
});
